import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';
import { SymbolSyntheticTranslator } from '../symbolSynthetic.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolSyntheticEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.load.started),
  switchMap((params) => {
    return dependencies.api.getSyntheticSymbolDetails(params).pipe(
      mergeMap((response) => {
        return [
          SymbolSyntheticAction.load.done({ params, result: SymbolSyntheticTranslator.fromApiDetails(response) }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolSyntheticAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
